module.exports = __webpack_public_path__ + "static/media/banner1.12ba66fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/steidle/images/banner1.jpg
// module id = 563
// module chunks = 0